import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { ReactElement, useState } from 'react';
import classNames from 'classnames';
import styles from './accordion.module.scss';
import { useMatomo } from '../../../utils/matomo';
import { ReactComponent as AccordionInfo } from '../../../assets/icons/icon-accordion-info.svg';
import { ReactComponent as AccordionChevron } from '../../../assets/icons/icon-accordion-chevron.svg';

/**
 * Properties for the accordion component
 */
export interface AccordionProps {
  id?: string;
  index: number;
  headline: ReactElement;
  headlineText: string;
  subHeadline?: ReactElement;
  details: ReactElement;
}

const isCurrentHash = (id: string | undefined): boolean => window.location.hash === '#' + id;

export const AccordionComponent = (props: AccordionProps): JSX.Element => {
  const { id, headline, headlineText, subHeadline, details, index } = props;
  const matomo = useMatomo();
  const [open, setOpen] = useState(isCurrentHash(id));

  function onChange(_: unknown, value: boolean): void {
    matomo.accordion(headlineText, value ? 'show' : 'hide');
    setOpen(value);
  }

  return (
    <Accordion
      id={id}
      className={classNames(styles.Accordion, {
        [styles.Open]: open,
        [styles.Even]: index % 2 === 0,
      })}
      data-test-id={`AccordionElement${index}`}
      expanded={open}
      onChange={onChange}
      disableGutters
      square
    >
      <AccordionSummary className={styles.AccordionSummary}>
        <div className={styles.AccordionInfo}>
          <AccordionInfo />
        </div>
        <div className={styles.AccordionHeadlineArea}>
          <div className={styles.AccordionHeadline}>{headline}</div>
          <div className={styles.AccordionSubHeadline}>{subHeadline}</div>
        </div>
        <div className={styles.AccordionChevron}>
          <AccordionChevron />
        </div>
      </AccordionSummary>
      <AccordionDetails className={styles.AccordionDetails}>{details}</AccordionDetails>
    </Accordion>
  );
};
